import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX, BP_TABLET_MAX } from '../../../assets/styles/breakpoints';

export const PredictionChartWrapperSC = styled.div`
  width: 100%;

  .content-wrap {
    display: flex;
  }

  .top-text-wrap {
    h3 {
      color: ${COLOR_WHITE};
      text-align: center;
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    .content-wrap {
      flex-direction: column;
    }
  }
`;

export const PredictionChartLeftColSC = styled.div`
  width: 35%;
  margin: 0 auto;
  .submit-wrap {
    button {
      width: 100%;
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 50%;
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    width: 100%;
  }
`;

export const PredictionChartSC = styled.div`
  width: 65%;

  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
    height: 400px;
  }
`;

export const ChartWrapSC = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 24px 24px 24px 60px;

  .loading-wrapper {
    position: absolute;
    inset: 0;
    background: rgba(43, 42, 60, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    border-radius: 20px;
    left: 5px;
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    padding: 24px;
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
